export default defineNuxtPlugin({
  name: 'serviceConfig',
  setup: () => {

    const { getServiceConfig } = useAuth()
    getServiceConfig()
    setInterval(getServiceConfig, 1000 * 30)

  }
})